import { Button, Dialog, DialogBody, DialogFooter } from '@blueprintjs/core';
import { DropDown, SelectItem } from '@zaiusinc/hera';
import React from 'react';
import DataSyncCgObjectsStore from '../../../../stores/object/DataSyncCgObjectsStore';
import { useObserver } from 'mobx-react-lite';

interface Props {
  languages: SelectItem[];
  isOpen: boolean;
  dataSyncCgObjectStore: DataSyncCgObjectsStore;
  onSave: (value: SelectItem) => void;
  onClose: () => void;
}

export const CGLanguageSelectDialog = (props: Props) => {

  const [selectedLanguage, setSelectedLanguage] = React.useState<SelectItem >();

  const saveLanguage = async () => {
    if (selectedLanguage) {
      props.onSave(selectedLanguage);
    }
  };

  return useObserver(() => (
    <Dialog title="Add New Language" isOpen={props.isOpen} onClose={props.onClose}>
      <DialogBody>
        {
          <DropDown
            initialContent="Select Language"
            items={props.languages}
            onItemSelect={function noRefCheck(item: any) {
              setSelectedLanguage(item);
            }}
            value={selectedLanguage}
            width={390}/>
        }
      </DialogBody>
      <DialogFooter actions={<Button loading={props.dataSyncCgObjectStore.savingNewLanguage} intent="primary" text="Save" disabled={!selectedLanguage}
        onClick={saveLanguage}/>} />
    </Dialog>
  ));
};
